import React from 'react';
import ReactDOM from 'react-dom';
import {applyMiddleware, createStore} from 'redux';
import { Provider } from 'react-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk'; 
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { PersistGate } from "redux-persist/integration/react";

import './index.css';
import 'styles/disability.css';
import 'bootstrap/dist/css/bootstrap.css';
import reportWebVitals from './reportWebVitals';
import RoutesComponent from './routers/Routes';
import rootReducer from './store/reducers'

const persistConfig = { key:"root", storage }
const persistedReducer = persistReducer(persistConfig, rootReducer);
let middleware = applyMiddleware(thunk);

if(process.env.NODE_ENV === "development"){
  middleware = composeWithDevTools(applyMiddleware(thunk));
}

export const store = createStore(persistedReducer, middleware);

let persistor = persistStore(store);

const jsx = (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <React.StrictMode>  
          <RoutesComponent /> 
      </React.StrictMode>
    </PersistGate>
  </Provider>
)

ReactDOM.render(jsx, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
